/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
export const SEARCH_RESULT_CONSTANTS = {
  SEARCH_RESULTS_LANDING_AEM_PATH: 'search',
  ONE: '1',
  FRP: 'FRP',
  DESKTOP_LIMIT: '16',
  TABLET_MOBILE_LIMIT: '12',
  DECIMAL: '.',
  EMPTY_STRING: '',
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  RELEVANCE: 'relevance',
  ALL: 'all',
  SEARCH_RESULT_MODULE: 'SearchResultsModule',
  FALSE: 'false',
  ASCENDING_PRICE_SORTORDER: '?i=1;sort=PRICE_SORT_ASC;type=global',
  DESCENDING_PRICE_SORTORDER: '?i=1;sort=PRICE_SORT_DESC;type=global',
  // TODO: Fixing ISO Defect. Will get a new User Story for the same.
  ERROR_MESSAGE: 'There is some error processing your request. Please try again after some time.',
  NO_RESULTS: 'no results',
};
